// ----------------------------------------------------------------------

export default function Menu(theme) {
  return {
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: theme.palette.background.paper,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: theme.palette.text.primary,
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
          },
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          backgroundColor: theme.palette.background.paper,
        },
      },
    },
  };
}
